<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Oficinas Reuniões Treinamentos"
            description="Gerencie suas inscrições e acompanhe seu progresso."
            url="/oficinas-treinamentos"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-2331"
            pageIdentifier="oficinas-treinamentos-participante"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw
                  ?.oficinas_treinamentos_participante_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw
                ?.oficinas_treinamentos_participante_ajuda || 0
            "
            keyAjudaModalInformacao="oficinas_treinamentos_participante_ajuda"
          />
        </div>

        <div class="col-md-12">
          <div class="card card-topo">
            <div
              class="d-flex flex-row align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center flex-shrink-0">
                <div class="filtros-container mr-2">
                  <button
                    @click="activeFilter = 'andamento'"
                    :class="[
                      'btn-filtro',
                      activeFilter === 'andamento' ? 'ativo' : 'inativo',
                    ]"
                  >
                    Em Andamento
                  </button>
                  <button
                    @click="activeFilter = 'finalizada'"
                    :class="[
                      'btn-filtro',
                      activeFilter === 'finalizada' ? 'ativo' : 'inativo',
                    ]"
                  >
                    Finalizadas
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabela de Dados -->
          <div class="box" style="margin-top: 0px">
            <v-card class="tabela">
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar treinamento"
                  class="input-bottom"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                @pagination="getPagination"
                :page="currentPage"
                :footer-props="{
                  itemsPerPageText: '',
                  'items-per-page-options': [10],
                  'disable-items-per-page': true,
                }"
                :loading="loading"
                loading-text="Carregando, Por favor espere"
                :headers="headers"
                :items="filteredTrainings"
                :search="search"
                item-key="id"
                class="elevation-1"
              >
                <template v-slot:[`footer.page-text`]="items">
                  <span class="paginacao">
                    {{ items.pageStart }} - {{ items.pageStop }} de
                    {{ items.itemsLength }}
                    {{
                      items.itemsLength === 1 ? 'treinamento' : 'treinamentos'
                    }}
                  </span>
                </template>

                <template v-slot:item.subtitulo="{ item }">
                  <span class="font-weight-bold">{{
                    item.subtitulo || item.nome
                  }}</span>
                </template>

                <template v-slot:item.responsavel="{ item }">
                  {{ item.responsavel || '-' }}
                </template>

                <template v-slot:item.meio="{ item }">
                  <div class="d-flex align-items-center">
                    <i :class="getMeioIcon(item.meio)" class="mr-2"></i>
                    {{ item.meio }}
                  </div>
                </template>

                <template v-slot:item.data="{ item }">
                  {{ formatarData(item.dataAtividade) }}
                </template>

                <template v-slot:item.inicio="{ item }">
                  {{ item.inicio }}
                </template>

                <template v-slot:item.fim="{ item }">
                  {{ item.fim }}
                </template>

                <template v-slot:item.status="{ item }">
                  <span :class="getStatusBadgeClass(item)">
                    <i :class="getStatusIcon(item)" class="mr-1"></i>
                    {{ getStatusTexto(item) }}
                  </span>
                </template>

                <template v-slot:item.acao="{ item }">
                  <button
                    v-if="item.status === 'andamento'"
                    @click="handleParticipar(item)"
                    :disabled="item.inscrito || participando"
                    :class="[
                      'btn btn-participar',
                      item.inscrito
                        ? 'btn-secondary text-white'
                        : 'btn-primary',
                    ]"
                  >
                    <i v-if="item.inscrito" class="icofont-check mr-1"></i>
                    {{ item.inscrito ? 'Inscrito' : 'Participar' }}
                  </button>
                  <button
                    v-else-if="
                      (item.status === 'finalizada' ||
                        item.ficha_atividade_coletiva?.st_ficha_finalizada ===
                          1) &&
                      item.inscrito
                    "
                    class="btn btn-participar"
                    :class="
                      jaAvaliou(item) ? 'btn-success text-white' : 'btn-primary'
                    "
                    @click="handleAvaliar(item)"
                    :disabled="jaAvaliou(item)"
                  >
                    {{ jaAvaliou(item) ? 'Avaliado' : 'Avaliar' }}
                  </button>
                  <button
                    v-else
                    class="btn btn-participar btn-secondary text-white"
                    disabled
                  >
                    Concluído
                  </button>
                </template>

                <template v-slot:no-data>
                  <div class="alert alert-info mb-0">
                    <b>Nenhum treinamento encontrado para este filtro.</b>
                  </div>
                </template>

                <template v-slot:no-results>
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Tente outro termo de
                      busca.</b
                    >
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmação de Participação -->
    <div
      v-if="mostrarModalParticipacao"
      class="modal fade show"
      style="display: block"
      tabindex="-1"
      role="dialog"
      @click.self="cancelarParticipacao"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
        @click.stop
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirmar Participação</h5>
            <button
              type="button"
              class="close"
              @click="cancelarParticipacao"
              :disabled="participando"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Tem certeza que deseja participar desta oficina/treinamento?</p>
            <div v-if="oficinaSelecionada" class="bg-light p-3 rounded mb-3">
              <p class="mb-1">
                <strong>Oficina/Treinamento:</strong>
                {{ oficinaSelecionada.subtitulo || oficinaSelecionada.nome }}
              </p>
              <p class="mb-1">
                <strong>Data:</strong>
                {{ formatarData(oficinaSelecionada.dataAtividade) }}
              </p>
              <p class="mb-1">
                <strong>Meio:</strong> {{ oficinaSelecionada.meio }}
              </p>
              <p class="mb-1">
                <strong>Mediada por:</strong>
                {{ oficinaSelecionada.responsavel || '-' }}
              </p>
              <p class="mb-0">
                <strong>Horário:</strong> {{ oficinaSelecionada.inicio }} às
                {{ oficinaSelecionada.fim }}
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="cancelarParticipacao"
              :disabled="participando"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="confirmarParticipacao"
              :disabled="participando"
            >
              <span
                v-if="participando"
                class="spinner-border spinner-border-sm mr-2"
                role="status"
              ></span>
              {{ participando ? 'Participando...' : 'Confirmar Participação' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="mostrarModalParticipacao" class="modal-backdrop fade show"></div>

    <!-- Modal de Avaliação -->
    <ModalAvaliacao
      :mostrar="mostrarModalAvaliacao"
      :oficina-id="oficinaSelecionadaParaAvaliacao?.id"
      :nome-oficina="
        oficinaSelecionadaParaAvaliacao?.subtitulo ||
        oficinaSelecionadaParaAvaliacao?.nome ||
        ''
      "
      :oficina="oficinaSelecionadaParaAvaliacao"
      @fechar="fecharModalAvaliacao"
      @avaliacao-enviada="onAvaliacaoEnviada"
    />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import { jwtDecode } from 'jwt-decode'
import ModalAvaliacao from './components/ModalAvaliacao.vue'
import ModalInformacao from '@/components/ModalInformacao.vue'
import SectionTitle from '@/components/SectionTitle'

export default {
  name: 'Profissionais',
  components: {
    Menu,
    ModalAvaliacao,
    ModalInformacao,
    SectionTitle,
  },
  data() {
    return {
      loading: true,
      participando: false,
      activeFilter: 'andamento',
      trainings: [],
      cpf: null,
      cns: null,
      mostrarModalParticipacao: false,
      oficinaSelecionada: null,
      mostrarModalAvaliacao: false,
      oficinaSelecionadaParaAvaliacao: null,
      currentPage: 1,
      search: '',
      headers: [
        {
          text: 'Treinamento / Oficina',
          align: 'start',
          filterable: true,
          value: 'subtitulo',
        },
        {
          text: 'Nome do Mediador',
          align: 'start',
          filterable: true,
          value: 'responsavel',
        },
        {
          text: 'Meio',
          align: 'start',
          filterable: false,
          value: 'meio',
        },
        {
          text: 'Data',
          align: 'start',
          filterable: false,
          value: 'data',
        },
        {
          text: 'Início',
          align: 'start',
          filterable: false,
          value: 'inicio',
        },
        {
          text: 'Fim',
          align: 'start',
          filterable: false,
          value: 'fim',
        },
        {
          text: 'Status',
          align: 'start',
          filterable: false,
          value: 'status',
        },
        {
          text: 'Ação',
          align: 'center',
          filterable: false,
          value: 'acao',
          sortable: false,
        },
      ],
    }
  },
  computed: {
    filteredTrainings() {
      return this.trainings.filter((t) => {
        if (!this.activeFilter) return true

        // Aba "Em Andamento": mostra todas em andamento
        if (this.activeFilter === 'andamento') {
          return t.status === 'andamento'
        }

        // Aba "Finalizadas": mostra apenas oficinas em que o usuário participou
        if (this.activeFilter === 'finalizada') {
          return t.status === 'finalizada' && t.inscrito
        }

        return true
      })
    },
    cpfUsuario() {
      if (this.cpf) {
        return this.cpf
      }
      if (this.$store.state.accessToken) {
        try {
          const decoded = jwtDecode(this.$store.state.accessToken)
          return decoded.cpf || decoded.nu_cpf || null
        } catch (error) {
          return null
        }
      }
      return null
    },
    nomeProfissional() {
      if (this.$store.state.username) {
        return this.$store.state.username
      }
      if (this.$store.state.accessToken) {
        try {
          const decoded = jwtDecode(this.$store.state.accessToken)
          return (
            decoded.nome || decoded.no_profissional || decoded.username || null
          )
        } catch (error) {
          return null
        }
      }
      return null
    },
    cnsParticipante() {
      if (this.cns) {
        return this.cns
      }
      if (this.$store.state.nu_cns && this.$store.state.nu_cns.trim() !== '') {
        return this.$store.state.nu_cns
      }
      if (this.$store.state.accessToken) {
        try {
          const decoded = jwtDecode(this.$store.state.accessToken)
          return decoded.nu_cns || null
        } catch (error) {
          return null
        }
      }
      return null
    },
    codIbge() {
      return this.$store.state.cod_ibge || ''
    },
  },
  async mounted() {
    await this.buscarCpfUsuario()
    await this.buscarCnsUsuario()
    await this.carregarTreinamentos()
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Busca o CPF do usuário autenticado na API.
     *
     * Caso a requisição falhe, tenta recuperar o CPF
     * a partir das informações contidas no token JWT.
     *
     * @returns {Promise<void>}
     */
    async buscarCpfUsuario() {
      try {
        const userAuth = await this.$api.post('/app/auth/usuario', {
          cod_ibge: this.$store.state.cod_ibge,
          id: this.$store.state.id,
        })
        if (userAuth && userAuth.data) {
          this.cpf = userAuth.data.cpf
        }
      } catch (error) {
        if (this.$store.state.accessToken) {
          try {
            const decoded = jwtDecode(this.$store.state.accessToken)
            this.cpf = decoded.cpf || decoded.nu_cpf || null
          } catch (e) {
            // Erro ao decodificar token
          }
        }
      }
    },

    /**
     * Busca o CNS do usuário autenticado.
     *
     * Prioriza os dados do Vuex e do token JWT.
     * Caso não encontre, consulta os profissionais e
     * suas lotações para identificar o CNS pelo CPF.
     *
     * @returns {Promise<void>}
     */
    async buscarCnsUsuario() {
      if (this.$store.state.nu_cns && this.$store.state.nu_cns.trim() !== '') {
        this.cns = this.$store.state.nu_cns
        return
      }

      if (this.$store.state.accessToken) {
        try {
          const decoded = jwtDecode(this.$store.state.accessToken)
          if (decoded.nu_cns && decoded.nu_cns.trim() !== '') {
            this.cns = decoded.nu_cns
            return
          }
        } catch (e) {
          // Erro ao decodificar token
        }
      }

      const cpf = this.cpfUsuario
      const codIbge = this.codIbge

      if (cpf && codIbge) {
        try {
          const cpfLimpo = String(cpf).replace(/\D/g, '')
          const response = await this.$api.get(
            `/app/profissionais-lotacoes/${codIbge}/1`
          )
          const profissionais = Array.isArray(response.data)
            ? response.data
            : []

          const profissional = profissionais.find((prof) => {
            const profCpf = prof.nu_cpf
              ? String(prof.nu_cpf).replace(/\D/g, '')
              : ''
            return profCpf === cpfLimpo
          })

          if (
            profissional &&
            profissional.nu_cns &&
            profissional.nu_cns.trim() !== ''
          ) {
            this.cns = profissional.nu_cns
          } else if (
            profissional &&
            profissional.lotacoes &&
            profissional.lotacoes.length > 0
          ) {
            const lotacaoAtiva =
              profissional.lotacoes.find((lot) => lot.ativo === 1) ||
              profissional.lotacoes[0]
            if (
              lotacaoAtiva &&
              lotacaoAtiva.nu_cns &&
              lotacaoAtiva.nu_cns.trim() !== ''
            ) {
              this.cns = lotacaoAtiva.nu_cns
            }
          }
        } catch (error) {
          // Erro ao buscar CNS
        }
      }
    },

    /**
     * Carrega as oficinas e treinamentos do município.
     *
     * Consulta a API, normaliza os dados retornados
     * e seleciona automaticamente a aba apropriada.
     *
     * @returns {Promise<void>}
     */
    async carregarTreinamentos() {
      this.loading = true
      try {
        const codIbge = this.codIbge

        if (!codIbge) {
          this.$toast.warning(
            'Não foi possível identificar o município.',
            'Aviso',
            {
              position: 'topRight',
              timeout: 5000,
            }
          )
          this.trainings = []
          return
        }

        const endpoint = `/app/oficinas-treinamentos/${codIbge}/oficinas`
        const response = await this.$api.get(endpoint)

        if (response && response.data) {
          const dados = response.data.data || response.data
          this.trainings = Array.isArray(dados)
            ? this.mapearTreinamentosDaAPI(dados)
            : []
          // Se não houver oficinas em andamento mas houver finalizadas, seleciona Finalizadas
          const temAndamento = this.trainings.some(
            (t) => t.status === 'andamento'
          )
          const temFinalizadas = this.trainings.some(
            (t) => t.status === 'finalizada'
          )
          if (!temAndamento && temFinalizadas) {
            this.activeFilter = 'finalizada'
          } else {
            this.activeFilter = 'andamento'
          }
        } else {
          this.trainings = []
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.trainings = []
        } else {
          this.$toast.error(
            'Erro ao carregar treinamentos. Tente novamente.',
            'Erro',
            {
              position: 'topRight',
              timeout: 5000,
            }
          )
          this.trainings = []
        }
      } finally {
        this.loading = false
      }
    },

    /**
     * Converte os dados das oficinas retornados pela API
     * para o formato utilizado pela tabela.
     *
     * Normaliza informações de identificação, horários,
     * situação, participantes e avaliações.
     *
     * @param {Array<Object>} data Oficinas retornadas pela API.
     * @returns {Array<Object>} Lista de oficinas normalizadas.
     */
    mapearTreinamentosDaAPI(data) {
      if (!Array.isArray(data)) {
        return []
      }

      const cpfUsuarioLimpo = this.cpfUsuario
        ? String(this.cpfUsuario).replace(/\D/g, '')
        : null

      return data.map((item) => {
        const id = item.id || null
        const nome = item.tipo_atividade || item.nome || 'Oficina/Treinamento'
        const meio = item.meio || 'Presencial'

        let inicio = '00:00'
        let fim = '00:00'
        if (item.inicio) {
          inicio = this.formatarHora(item.inicio)
        }
        if (item.fim) {
          fim = this.formatarHora(item.fim)
        }

        const stFinalizada =
          item.ficha_atividade_coletiva?.st_ficha_finalizada || 0
        const status = stFinalizada === 1 ? 'finalizada' : 'andamento'

        const participantes = item.participantes || []
        const inscrito = cpfUsuarioLimpo
          ? participantes.some(
              (cpf) => String(cpf).replace(/\D/g, '') === cpfUsuarioLimpo
            )
          : false

        return {
          id: id,
          nome: nome,
          subtitulo: item.subtitulo || null,
          responsavel: item.responsavel || null,
          meio: meio,
          inicio: inicio,
          fim: fim,
          status: status,
          inscrito: inscrito,
          dataAtividade: item.data_atividade || item.inicio || null,
          numeroParticipantes: item.numero_participantes || 0,
          quem_avaliou: item.quem_avaliou || [],
          ficha_atividade_coletiva: item.ficha_atividade_coletiva || null,
        }
      })
    },

    /**
     * Retorna a classe CSS do ícone correspondente
     * ao meio de realização da oficina.
     *
     * @param {string} meio Meio de realização da atividade.
     * @returns {string} Classes CSS do ícone.
     */
    getMeioIcon(meio) {
      switch (meio) {
        case 'Presencial':
          return 'icofont-users-alt-5 text-primary'
        case 'Telepresença':
          return 'icofont-video-cam text-info'
        case '100% Online':
          return 'icofont-globe text-success'
        default:
          return 'icofont-location-pin text-secondary'
      }
    },

    /**
     * Obtém a descrição textual da situação da oficina.
     *
     * @param {Object} item Dados da oficina.
     * @returns {string} Descrição da situação.
     */
    getStatusTexto(item) {
      return item.status === 'andamento' ? 'Em andamento' : 'Finalizada'
    },

    /**
     * Retorna a classe CSS do ícone correspondente
     * à situação da oficina.
     *
     * @param {Object} item Dados da oficina.
     * @returns {string} Classe CSS do ícone.
     */
    getStatusIcon(item) {
      return item.status === 'andamento'
        ? 'icofont-play-circle'
        : 'icofont-check-circled'
    },

    /**
     * Retorna as classes CSS do badge de situação.
     *
     * @param {Object} item Dados da oficina.
     * @returns {string} Classes CSS do badge.
     */
    getStatusBadgeClass(item) {
      return item.status === 'andamento'
        ? 'badge badge-primary'
        : 'badge badge-success'
    },

    /**
     * Inicia o processo de inscrição em uma oficina.
     *
     * Verifica se o usuário já está inscrito, se existe
     * uma inscrição em andamento e se os dados necessários
     * estão disponíveis antes de abrir a confirmação.
     *
     * @param {Object} item Oficina selecionada.
     * @returns {void}
     */
    handleParticipar(item) {
      if (item.inscrito || this.participando) return

      if (!item.id) {
        this.$toast.error('ID da oficina não encontrado.', 'Erro', {
          position: 'topRight',
          timeout: 5000,
        })
        return
      }

      const cpf = this.cpfUsuario
      if (!cpf) {
        this.$toast.error(
          'Não foi possível identificar o CPF do profissional.',
          'Erro',
          {
            position: 'topRight',
            timeout: 5000,
          }
        )
        return
      }

      this.oficinaSelecionada = item
      this.mostrarModalParticipacao = true
    },

    /**
     * Cancela a confirmação de participação.
     *
     * Fecha o modal e limpa a oficina selecionada.
     *
     * @returns {void}
     */
    cancelarParticipacao() {
      this.mostrarModalParticipacao = false
      this.oficinaSelecionada = null
    },

    /**
     * Confirma a inscrição do usuário na oficina.
     *
     * Envia os dados do participante para a API,
     * atualiza a listagem e apresenta uma notificação
     * com o resultado da operação.
     *
     * @returns {Promise<void>}
     */
    async confirmarParticipacao() {
      if (!this.oficinaSelecionada || this.participando) return

      const item = this.oficinaSelecionada
      const cpf = this.cpfUsuario
      const nomeProfissional = this.nomeProfissional || 'Profissional'
      const codIbge = this.codIbge

      if (!codIbge) {
        this.$toast.error(
          'Não foi possível identificar o código IBGE do município.',
          'Erro',
          {
            position: 'topRight',
            timeout: 5000,
          }
        )
        return
      }

      this.participando = true
      try {
        const endpoint = `/app/oficinas-treinamentos/oficina/participante`
        const cns = this.cnsParticipante

        const payload = {
          id_oficina_treinamento: item.id,
          cod_ibge: codIbge,
          cpf_participante: String(cpf).replace(/\D/g, ''),
          nome_participante: nomeProfissional,
          cns_participante: cns || null,
        }

        const response = await this.$api.post(endpoint, payload)

        if (response && response.data && response.data.error === true) {
          throw new Error(
            response.data.message || 'Erro ao realizar inscrição.'
          )
        }

        this.mostrarModalParticipacao = false
        this.oficinaSelecionada = null
        await this.carregarTreinamentos()

        this.$toast.success('Inscrição realizada com sucesso!', 'Sucesso', {
          position: 'topRight',
          timeout: 3000,
        })
      } catch (error) {
        let mensagemErro = 'Erro ao realizar inscrição. Tente novamente.'

        if (error.response) {
          const data = error.response.data
          if (data?.message) {
            mensagemErro = data.message
          } else if (data?.error && data.error !== true) {
            mensagemErro = String(data.error)
          }
        } else if (error.message) {
          mensagemErro = error.message
        }

        this.$toast.error(mensagemErro, 'Erro', {
          position: 'topRight',
          timeout: 5000,
        })
      } finally {
        this.participando = false
      }
    },

    /**
     * Exibe uma notificação informativa sobre
     * a disponibilidade da central de ajuda.
     *
     * @returns {void}
     */
    abrirAjuda() {
      this.$toast.info('Central de Ajuda em breve', 'Info', {
        position: 'topRight',
        timeout: 3000,
      })
    },

    /**
     * Formata uma data e hora para o padrão HH:mm.
     *
     * @param {string|Date} dataHora Data e hora a formatar.
     * @returns {string} Horário formatado ou string vazia.
     */
    formatarHora(dataHora) {
      if (!dataHora) return ''
      const date = new Date(dataHora)
      const horas = String(date.getHours()).padStart(2, '0')
      const minutos = String(date.getMinutes()).padStart(2, '0')
      return `${horas}:${minutos}`
    },

    /**
     * Formata uma data para o padrão brasileiro.
     *
     * Retorna um hífen quando a data não está
     * disponível ou não é válida.
     *
     * @param {string|Date} dataAtividade Data da atividade.
     * @returns {string} Data formatada em pt-BR ou hífen.
     */
    formatarData(dataAtividade) {
      if (!dataAtividade) return '-'
      try {
        const date = new Date(dataAtividade)
        if (isNaN(date.getTime())) return '-'
        return date.toLocaleDateString('pt-BR')
      } catch (error) {
        return '-'
      }
    },

    /**
     * Verifica se o usuário autenticado já avaliou a oficina.
     *
     * Compara o CPF do usuário com a lista de CPFs
     * dos participantes que realizaram a avaliação.
     *
     * @param {Object} item Oficina a verificar.
     * @returns {boolean} Verdadeiro se já realizou a avaliação.
     */
    jaAvaliou(item) {
      if (
        !item.quem_avaliou ||
        !Array.isArray(item.quem_avaliou) ||
        item.quem_avaliou.length === 0
      ) {
        return false
      }

      const cpfUsuarioLimpo = this.cpfUsuario
        ? String(this.cpfUsuario).replace(/\D/g, '')
        : null

      if (!cpfUsuarioLimpo) {
        return false
      }

      return item.quem_avaliou.some((cpf) => {
        const cpfAvaliadoLimpo = String(cpf).replace(/\D/g, '')
        return cpfAvaliadoLimpo === cpfUsuarioLimpo
      })
    },

    /**
     * Abre o modal de avaliação da oficina selecionada.
     *
     * Armazena a oficina e ativa a exibição do modal.
     *
     * @param {Object} item Oficina selecionada.
     * @returns {void}
     */
    handleAvaliar(item) {
      this.oficinaSelecionadaParaAvaliacao = item
      this.mostrarModalAvaliacao = true
    },

    /**
     * Fecha o modal de avaliação.
     *
     * Oculta o modal e limpa a oficina selecionada.
     *
     * @returns {void}
     */
    fecharModalAvaliacao() {
      this.mostrarModalAvaliacao = false
      this.oficinaSelecionadaParaAvaliacao = null
    },

    /**
     * Processa o evento de avaliação enviada.
     *
     * Exibe uma notificação de sucesso e atualiza
     * a listagem de oficinas e treinamentos.
     *
     * @returns {Promise<void>}
     */
    async onAvaliacaoEnviada() {
      this.$toast.success('Avaliação enviada com sucesso!', 'Sucesso', {
        position: 'topRight',
        timeout: 3000,
      })
      await this.carregarTreinamentos()
    },
  },
}
</script>

<style scoped>
.card-topo {
  border-radius: 15px 15px 0 0;
  border-bottom: none;
}

.card-tabela {
  border-radius: 0 0 15px 15px;
  border-top: none;
}

.btn-voltar-circular {
  background-color: #fff;
  border: 1px solid #dee2e6;
  color: #6c757d;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.btn-voltar-circular i {
  font-size: 1.2rem;
}

.btn-voltar-circular:hover {
  background-color: #f8f9fa;
  color: #0fafd7;
  border-color: #0fafd7;
  transform: translateX(-2px);
}

.btn-ajuda-circular {
  background-color: transparent;
  border: 1px solid transparent;
  color: #888888;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.2s;
  box-shadow: none;
}

.btn-ajuda-circular:hover {
  background-color: #e9ecef;
  color: #888888;
  border-color: transparent;
  box-shadow: none;
}

.btn-ajuda-circular i {
  text-shadow: none;
  filter: none;
  font-size: 1.3rem;
}

.filtros-container {
  display: flex;
  align-items: center;
  background-color: #f5f9fa;
  padding: 4px;
  border-radius: 8px;
  gap: 0;
  border: 1px solid rgba(15, 175, 215, 0.12);
}

.btn-filtro {
  padding: 6px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  white-space: nowrap;
}

.btn-filtro.ativo {
  background-color: #0fafd7;
  color: #fff;
  box-shadow: 0 1px 2px rgba(15, 175, 215, 0.3);
}

.btn-filtro.inativo {
  background-color: transparent;
  color: #6c757d;
}

.btn-filtro.inativo:hover {
  background-color: rgba(15, 175, 215, 0.08);
  color: #0fafd7;
}

.btn-filtro.ativo:hover {
  background-color: #0d98bb;
  box-shadow: 0 1px 3px rgba(15, 175, 215, 0.35);
}

.hover-row:hover {
  background-color: #f8f9fa;
}

.badge-dot {
  width: 8px;
  height: 8px;
  padding: 0;
  border-radius: 50%;
  display: inline-block;
}

.badge-primary {
  background-color: rgb(15, 175, 215);
  color: white;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
}

.badge-success {
  background-color: #28a745;
  color: white;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
}

.btn-participar {
  padding: 0.25rem 0.75rem;
  font-size: 0.8rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  text-transform: none;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
}

.btn-participar i {
  margin-right: 0.25rem;
  flex-shrink: 0;
}

.btn-participar.btn-primary {
  color: white;
}

.btn-participar.btn-primary:hover {
  color: white;
  background-color: #0056b3;
  border-color: #0056b3;
}

.btn-participar.btn-secondary {
  color: white;
}

.btn-participar.btn-secondary:hover {
  color: white;
  background-color: #5a6268;
  border-color: #545b62;
}

.box {
  margin-top: 0px;
}

.tabela {
  padding: 0px;
}

.input-bottom {
  margin-bottom: 0;
}

.paginacao {
  font-size: 0.875rem;
  color: #6c757d;
}

/* Estilos para v-data-table */
.v-data-table {
  overflow: visible !important;
}

.v-data-table__wrapper {
  overflow: visible !important;
}

.v-data-table table {
  overflow: visible !important;
}

.v-data-table tbody {
  overflow: visible !important;
}

.v-data-table tbody tr {
  overflow: visible !important;
}

.v-data-table tbody td {
  overflow: visible !important;
  position: relative;
}

@media (max-width: 768px) {
  .d-flex.flex-row {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .gap-3 {
    gap: 1rem !important;
  }
}
</style>
